import { WiredComponents } from '@wix/payment-methods-banner';
import { TextComponent } from './Text';
import { TextButtonComponent } from './TextButton';

export const wiredComponents: WiredComponents = {
  Text: TextComponent,
  TextButton: TextButtonComponent,
  // Image: ThumbnailImage,
} as any; // TODO: remove "as any" after providing Image component
